import axios from "./axios";

export async function fetchNotes(controller) {
  return axios({ method: "get", url: "/notes/", params: controller });
}

export async function createNote(payload) {
  return axios.post(`/notes/`, { note: payload });
}
